const API = "/api";

export async function req(path, opts = {}) {
  const o = { credentials: "include", ...opts };
  if (o.body && typeof o.body !== "string" && !(o.body instanceof FormData)) {
    o.headers = { "Content-Type": "application/json", ...(o.headers || {}) };
    o.body = JSON.stringify(o.body);
  }
  const res = await fetch(API + path, o);
  if (!res.ok) {
    let msg = "Request failed (" + res.status + ")";
    try {
      const j = await res.json();
      const d = j.detail;
      msg = typeof d === "string" ? d : Array.isArray(d) ? d.map((e) => e.msg || JSON.stringify(e)).join(" ") : msg;
    } catch (e) {}
    throw new Error(msg);
  }
  const ct = res.headers.get("content-type") || "";
  return ct.includes("json") ? res.json() : res.text();
}

export const L = (en = "", bn = "") => ({ en, bn });
export const tr = (o, lang = "en") => (o == null ? "" : typeof o === "string" ? o : o[lang] || o.en || "");
